import { createAction, createAsyncAction } from "typesafe-actions";
import { ICreateSubscriptionResponse, ISubscriptionPlansResponse, IUserSubscription } from "src/models/Subscription";

export const resetSubscriptions = createAction("subscription/RESET")<void>();

export const fetchPlans = createAsyncAction(
  "subscription/PLANS_REQUEST",
  "subscription/PLANS_SUCCESS",
  "subscription/PLANS_FAILURE"
)<{ username: string }, ISubscriptionPlansResponse, Error>();

export const fetchUserSubscriptions = createAsyncAction(
  "subscription/USER_SUBS_REQUEST",
  "subscription/USER_SUBS_SUCCESS",
  "subscription/USER_SUBS_FAILURE"
)<{ username: string }, IUserSubscription[], Error>();

export const createSubscription = createAsyncAction(
  "subscription/CREATE_REQUEST",
  "subscription/CREATE_SUCCESS",
  "subscription/CREATE_FAILURE"
)<
  { username: string; payload: Omit<IUserSubscription, "subscriptionId"> },
  ICreateSubscriptionResponse,
  Error
>();

export const deleteSubscription = createAsyncAction(
  "subscription/DELETE_REQUEST",
  "subscription/DELETE_SUCCESS",
  "subscription/DELETE_FAILURE"
)<{ username: string; subscriptionId: string }, string, Error>();
